<ng-container>
  @if (flightsPageRedirectionUrl()) {
    <div class="book-flights-cta">
      <a id="bookNowButton" class="btn bold-type no-underline" [finLink]="flightsPageRedirectionUrl()" [external]="true"
        >{{ 'bookNow' | finLocalization }}
      </a>
    </div>
  }

  <div class="mr-xxsmall-t section col-1-12 md-col-2-11">
    <smt-gcovwidget
      #smartvelWidget
      [attr.apikey]="smartvelApiKey"
      lang="en"
      [attr.roundtrip]="oneway() !== true"
      [attr.destination]="destination()"
      [attr.origin]="origin()"
      (finMutationObserver)="onWidgetChange($event)"
      mutationObserverInitConfigKey="travelRestrictions"
    />
  </div>
</ng-container>
